/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_TimelineInputs */

const en_layout_timeline = /** @type {(inputs: Layout_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeline`)
};

const de_layout_timeline = /** @type {(inputs: Layout_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitleiste`)
};

/**
* | output |
* | --- |
* | "Timeline" |
*
* @param {Layout_TimelineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const layout_timeline = /** @type {((inputs?: Layout_TimelineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_TimelineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_layout_timeline(inputs)
	return en_layout_timeline(inputs)
});